/*
 * Contact slider
 */
class RLM_ToolsTabs {
    constructor (wrapper) {
        this.mainWrapper = $(wrapper);

        if (!this.mainWrapper.find('.js-tools-tabs').length) {
            return;
        }
        
        this.initState();        
        this.initEvents();
    }

    initState () {
        this.currentIndex = 0;
        this.win = jQuery(window);
        this.wrapper = this.mainWrapper.find('.js-tools-tabs');
        this.tabs = this.wrapper.find('.tablinks-wrapper .tablinks');
        this.dots = this.wrapper.find('.tablinks-line .tablinks-line-dot');
        this.contents = this.wrapper.find('.tabcontent-wrapper .tabcontent');
    }

    initEvents () {
        let self = this;

        for (let i = 0; i < this.tabs.length; i++) {
            this.tabs.eq(i).on('click', function () {
                self.tabs.removeClass('is-active');
                self.dots.removeClass('is-active');
                self.contents.removeClass('is-active');
                self.contents.parent().find('.is-visible').removeClass('is-visible');
                let nextIndex = parseInt($(this).attr('data-index'), 10);
                this.currentIndex = nextIndex;
                self.tabs.eq(nextIndex).addClass('is-active');
                self.dots.eq(nextIndex).addClass('is-active');
                self.contents.eq(nextIndex).addClass('is-active');
                let animatedElements = self.contents.eq(nextIndex).find('.tabcontent-title, .tabcontent-desc, .tabcontent-tool');
                $(window).trigger('resize');

                for (let i = 0; i < animatedElements.length; i++) {
                    let elementToShow = animatedElements.eq(i);
                    
                    setTimeout(() => {
                        elementToShow.addClass('is-visible');
                    }, i * 75);
                }
            });
        }
    }
}

new RLM_ToolsTabs(document.body);